import { render, staticRenderFns } from "./article_edit.vue?vue&type=template&id=d644b858&scoped=true"
import script from "./article_edit.vue?vue&type=script&lang=ts"
export * from "./article_edit.vue?vue&type=script&lang=ts"
import style0 from "./article_edit.vue?vue&type=style&index=0&id=d644b858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d644b858",
  null
  
)

export default component.exports